export const getModalStatus = (state) => {
    return state.show_modal
}

export const getMessage = (state) => {
    return state.message
}

export const getSchedulerModalStatus = (state) => {
    return state.show_scheduler_modal
}

export const getSchedulerEditModalStatus = (state) => {
    return state.show_scheduler_edit_modal
}

export const getSchedulerEditingId = (state) => {
    return state.edit_scheduler_id
}

export const getActivationName = (state) => {
    return state.name
}

export const getQuery = (state) => {
    return state.query
}

export const getCreateCohortStatus = (state) => {
    return state.create_cohort
}

export const getNotificationStatus = (state) => {
    return state.notification
}

export const isFieldLoadingStatus = (state) => (field_name) => {
    return state.loadings.includes(field_name);
}

export const getAnalysisType = (state) => (dataset) => {
    if (dataset === 'cross') {
        return "Cross"
    } else {
        return state.analyses_types[dataset].analysis_type
    }
}

export const getAnalysisTypes = (state) => (dataset) => {
    return state.analyses_types[dataset].all_analysis_types
}

export const getCohortsAll = (state) => (dataset) => {
    return state.datasets[dataset].cohorts.all
}

export const getCohortsCopy = (state) => (dataset) => {
    return state.datasets[dataset].cohorts.copy
}

export const getCohortsSelected = (state) => (dataset) => {
    return state.datasets[dataset].cohorts.selected
}

export const getCohortsSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].cohorts.search
}

export const getSignalProvidersAll = (state) => (dataset) => {
    return state.datasets[dataset].signal_providers.all
}

export const getSignalProvidersCopy = (state) => (dataset) => {
    return state.datasets[dataset].signal_providers.copy
}

export const getSignalProvidersSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return []
    } else {
        return state.datasets[dataset].signal_providers.selected
    }
}

export const getSignalProvidersSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].signal_providers.search
}

export const getSegmentsAll = (state) => (dataset) => {
    return state.datasets[dataset].segments.all
}

export const getSegmentsCopy = (state) => (dataset) => {
    return state.datasets[dataset].segments.copy
}

export const getSegmentsSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return []
    } else {
        return state.datasets[dataset].segments.selected
    }
}

export const getSegmentsSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].segments.search
}

export const getCategoriesAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.categories.all
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.categories.all
    } else {
        return state.datasets[dataset].categories.all
    }
}

export const getCategoriesCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.categories.copy
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.categories.copy
    } else {
        return state.datasets[dataset].categories.copy
    }
}

export const getCategoriesSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.categories.selected
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.categories.selected
    } else {
        return state.datasets[dataset].categories.selected
    }
}

export const getCategoriesSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.categories.search
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.categories.search
    } else {
        return state.datasets[dataset].categories.search
    }
}

export const getAppsCategoriesAll = (state) => (dataset) => {
    return state.datasets[dataset].apps_categories.all
}

export const getAppsCategoriesCopy = (state) => (dataset) => {
    return state.datasets[dataset].apps_categories.copy
}

export const getAppsCategoriesSelected = (state) => (dataset) => {
    return state.datasets[dataset].apps_categories.selected
}

export const getAppsCategoriesSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].apps_categories.search
}

export const getAppsTagsAll = (state) => (dataset) => {
    return state.datasets[dataset].apps_tags.all
}

export const getAppsTagsCopy = (state) => (dataset) => {
    return state.datasets[dataset].apps_tags.copy
}

export const getAppsTagsSelected = (state) => (dataset) => {
    return state.datasets[dataset].apps_tags.selected
}

export const getAppsTagsSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].apps_tags.search
}

export const getAppsNamesAll = (state) => (dataset) => {
    return state.datasets[dataset].apps_names.all
}

export const getAppsNamesCopy = (state) => (dataset) => {
    return state.datasets[dataset].apps_names.copy
}

export const getAppsNamesSelected = (state) => (dataset) => {
    return state.datasets[dataset].apps_names.selected
}

export const getAppsNamesSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].apps_names.search
}

export const getAppsBundleidsAll = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.all
}

export const getAppsBundleidsCopy = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.copy
}

export const getAppsBundleidsSelected = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.selected
}

export const getAppsBundleidsSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.search
}

export const getAppsBundleidsInsertCustomStatus = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.insert_custom
}

export const getAppsBundleidsCustomIds = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.ids
}

export const getAppsBundleidsAllIds = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.all_ids
}

export const getAppsBundleidsConcatenated = (state) => (dataset) => {
    return state.datasets[dataset].apps_bundleids.concatenated
}

export const getAppsOsAll = (state) => (dataset) => {
    return state.datasets[dataset].apps_os.all
}

export const getAppsOsCopy = (state) => (dataset) => {
    return state.datasets[dataset].apps_os.copy
}

export const getAppsOsSelected = (state) => (dataset) => {
    return state.datasets[dataset].apps_os.selected
}

export const getAppsOsSearchInput = (state) => (dataset) => {
    return state.datasets[dataset].apps_os.search
}

export const getBrandsAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.brands.all
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.brands.all
    } else {
        return state.datasets[dataset].brands.all
    }
}

export const getBrandsCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.brands.copy
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.brands.copy
    } else {
        return state.datasets[dataset].brands.copy
    }
}

export const getBrandsSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.brands.selected
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.brands.selected
    } else {
        return state.datasets[dataset].brands.selected
    }
}

export const getBrandsSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.brands.search
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.brands.search
    } else {
        return state.datasets[dataset].brands.search
    }
}

export const getLocationsAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.all
    } else {
        return state.datasets[dataset].locations.all
    }
}

export const getLocationsCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.copy
    } else {
        return state.datasets[dataset].locations.copy
    }
}

export const getLocationsSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.selected
    } else {
        return state.datasets[dataset].locations.selected
    }
}

export const getLocationsSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.search
    } else {
        return state.datasets[dataset].locations.search
    }
}

export const getLocationsInsertCustomStatus = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.insert_custom
    } else {
        return state.datasets[dataset].locations.insert_custom
    }
}

export const getLocationsCustomIds = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.ids
    } else {
        return state.datasets[dataset].locations.ids
    }
}

export const getLocationsAllIds = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.all_ids
    } else {
        return state.datasets[dataset].locations.all_ids
    }
}

export const getLocationsConcatenated = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.locations.concatenated
    } else {
        return state.datasets[dataset].locations.concatenated
    }
}

export const getCountriesAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.countries.all
    } else {
        return state.datasets[dataset].countries.all
    }
}

export const getCountriesCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.countries.copy
    } else {
        return state.datasets[dataset].countries.copy
    }
}

export const getCountriesSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.countries.selected
    } else {
        return state.datasets[dataset].countries.selected
    }
}

export const getCountriesSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.countries.search
    } else {
        return state.datasets[dataset].countries.search
    }
}

export const getStatesAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.states.all
    } else {
        return state.datasets[dataset].states.all
    }
}

export const getStatesCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.states.copy
    } else {
        return state.datasets[dataset].states.copy
    }
}

export const getStatesSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.states.selected
    } else {
        return state.datasets[dataset].states.selected
    }
}

export const getStatesSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.states.search
    } else {
        return state.datasets[dataset].states.search
    }
}

export const getDmasAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.dmas.all
    } else {
        return state.datasets[dataset].dmas.all
    }
}

export const getDmasCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.dmas.copy
    } else {
        return state.datasets[dataset].dmas.copy
    }
}

export const getDmasSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.dmas.selected
    } else {
        return state.datasets[dataset].dmas.selected
    }
}

export const getDmasSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.dmas.search
    } else {
        return state.datasets[dataset].dmas.search
    }
}

export const getCitiesAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.cities.all
    } else {
        return state.datasets[dataset].cities.all
    }
}

export const getCitiesCopy = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.cities.copy
    } else {
        return state.datasets[dataset].cities.copy
    }
}

export const getCitiesSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.cities.selected
    } else {
        return state.datasets[dataset].cities.selected
    }
}

export const getCitiesSearchInput = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.cities.search
    } else {
        return state.datasets[dataset].cities.search
    }
}

export const getZipCodes = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.zip_codes
    } else {
        return state.datasets[dataset].zip_codes
    }
}

export const getRecencyStart = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.recency.start_date
    } else {
        return state.datasets[dataset].recency.start_date
    }
}

export const getRecencyEnd = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.recency.end_date
    } else {
        return state.datasets[dataset].recency.end_date
    }
}

export const getLimitsStatus = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.status
    } else {
        return state.datasets[dataset].limits.status
    }
}

export const getLimitsTimeStatus = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.time.status
    } else {
        return state.datasets[dataset].limits.time.status
    }
}

export const getLimitsTime = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.time.limits
    } else {
        return state.datasets[dataset].limits.time.limits
    }
}

export const getLimitsDistanceStatus = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.distance.status
    } else {
        return state.datasets[dataset].limits.distance.status
    }
}

export const getLimitsDistance = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.distance.limit
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.distance
    } else {
        return state.datasets[dataset].limits.distance.limit
    }
}

export const getLimitsDistanceUnit = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.limits.distance.unit
    } else if (dataset.toString().startsWith('comp')) {
        let comp_dataset_id = dataset.split("_")[1];
        return state.datasets[comp_dataset_id].competitors.unit
    } else {
        return state.datasets[dataset].limits.distance.unit
    }
}

export const getFiltersAll = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.filters.all
    } else {
        return state.filters.all
    }
}

export const getFiltersSelected = (state) => (dataset) => {
    if (dataset === 'cross') {
        return state.analyses.cross_visitation.filters.selected
    } else {
        return state.filters.selected
    }
}

export const getAnalysesAudienceStatus = (state) => {
    return state.analyses.audience.status
}

export const getAnalysesCrossVisitationStatus = (state) => {
    return state.analyses.cross_visitation.status
}

export const getAnalysesCrossVisitationPoiLocationLevel = (state) => {
    return state.analyses.cross_visitation.poi_location_level
}

export const getAnalysesFrequencyStatus = (state) => {
    return state.analyses.frequency.status
}

export const getAnalysesFrequencyIsDayPart = (state) => {
    return state.analyses.frequency.day_part
}

export const getAnalysesDistanceStatus = (state) => {
    return state.analyses.distance.status
}

export const getSchedulerStep = (state) => {
    return state.scheduler.step
}

export const getSchedulerAudienceType = (state) => {
    return state.scheduler.audience_type
}

export const getSchedulerPeriod = (state) => {
    return state.scheduler.period
}

export const getSchedulerAudiences = (state) => {
    return state.scheduler.audiences
}

export const getSchedulerSelectedAudience = (state) => {
    return state.scheduler.selected_audience_id
}

export const getSchedulerStartDate = (state) => {
    return state.scheduler.start_date
}

export const getSchedulerEndDate = (state) => {
    return state.scheduler.end_date
}

export const getSchedulerFullTime = (state) => {
    return state.scheduler.full_time
}

export const getSchedulerTime = (state) => {
    return state.scheduler.time
}

export const getSchedulerMessage = (state) => {
    return state.scheduler.message
}


export const getSchedulerActivationFrequency = (state) => {
    return state.scheduler.act_frequency
}

export const getSchedulerRecurrenceType = (state) => {
    return state.scheduler.recurrence_type
}

export const getSchedulerEndingType = (state) => {
    return state.scheduler.ending_type
}

export const getSchedulerEndingRecurrences = (state) => {
    return state.scheduler.ending_after_recurrences
}

export const getSchedulerAutoActivateStatus = (state) => {
    return state.scheduler.auto_activate
}

export const getSchedulerTimeZone = (state) => {
    return state.scheduler.time_zone
}

export const getAnonymizedFields = (state) => (dataset) => {
    return state.datasets[dataset].anonymized_fields
}

export const getAnonymizedDataAll = (state) => (value) => {
    return state.datasets[value.dataset].anonymized[value.item].all
}

export const getAnonymizedDataCopy = (state) => (value) => {
    return state.datasets[value.dataset].anonymized[value.item].copy
}

export const getAnonymizedData = (state) => (value) => {
    return state.datasets[value.dataset].anonymized[value.item].selected
}

export const getAnonymizedDataSearch = (state) => (value) => {
    return state.datasets[value.dataset].anonymized[value.item].search
}